import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from 'primeng/paginator';
import { Paginator, PaginatorModule } from 'primeng/paginator';
let CapturumPaginatorComponent = /*#__PURE__*/(() => {
  class CapturumPaginatorComponent {
    constructor() {
      this.changePage = new EventEmitter();
    }
    static {
      this.ɵfac = function CapturumPaginatorComponent_Factory(t) {
        return new (t || CapturumPaginatorComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumPaginatorComponent,
        selectors: [["cap-paginator"]],
        viewQuery: function CapturumPaginatorComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(Paginator, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.primePaginator = _t.first);
          }
        },
        inputs: {
          pagination: "pagination"
        },
        outputs: {
          changePage: "changePage"
        },
        decls: 1,
        vars: 3,
        consts: [[3, "rows", "totalRecords", "first", "onPageChange"]],
        template: function CapturumPaginatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "p-paginator", 0);
            i0.ɵɵlistener("onPageChange", function CapturumPaginatorComponent_Template_p_paginator_onPageChange_0_listener($event) {
              return ctx.changePage == null ? null : ctx.changePage.emit($event == null ? null : $event.page);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("rows", ctx.pagination == null ? null : ctx.pagination.per_page)("totalRecords", ctx.pagination == null ? null : ctx.pagination.total)("first", (ctx.pagination == null ? null : ctx.pagination.per_page) * ((ctx.pagination == null ? null : ctx.pagination.current_page) - 1));
          }
        },
        dependencies: [i1.Paginator]
      });
    }
  }
  return CapturumPaginatorComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumPaginatorModule = /*#__PURE__*/(() => {
  class CapturumPaginatorModule {
    static {
      this.ɵfac = function CapturumPaginatorModule_Factory(t) {
        return new (t || CapturumPaginatorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumPaginatorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, PaginatorModule]
      });
    }
  }
  return CapturumPaginatorModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumPaginatorComponent, CapturumPaginatorModule };
